<template>
    <nc-container>
        <nc-row>
            <nc-column>
                <h1>Page not found</h1>
            </nc-column>
        </nc-row>
    </nc-container>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'NotFound',
});
</script>